import axios from "./axiosInstance";

export const createNewRole = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`/role/create`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateRoleData = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`role/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

// Settings asks for every group and role at once: the API pages them, by
// default 10 to a page (or the account's own page size).
const ALL_AT_ONCE = { perPage: 100 };

export const fetchAllPermissions = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`/permissions`, { params: ALL_AT_ONCE });
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchAllRoles = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`/role/get`, { params: ALL_AT_ONCE });
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

// Adds the ready-made roles the account doesn't have yet (owner only). The
// result lists the roles it "created" and those it "kept" as they were.
export const addReadyMadeRoles = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`/role/ready-made`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteRoleData = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`role/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const createNewShipperUser = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`/shipper-user/create`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchShipperUsers = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`/shipper-user`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const searchShipperUsers = async (name, page, param) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `/shipper-user?name=${name}&&${page ? `page=${page}` : ""}${param ?? ""}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateShipperUserData = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`shipper-user/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteShipperUser = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`shipper-user/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateAccountStatus = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.put(
      `shipper-user/status/${data.status}/${data.id}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateGeneralSettings = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`general-setting/set-setting`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getProfileData = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`get/profile`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateProfileData = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`update/profile`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateProfilePassword = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`change/password`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
